/**
 * Customises the Shopify Forms embed: side-by-side fields and a lead-in heading.
 *
 * The form renders in a shadow root, so theme stylesheets cannot reach it. We
 * adopt a stylesheet into the shadow root instead. Selectors key off data-testid
 * where possible, never the hashed class names, which change on app updates.
 */
(function () {
  // Fields to render half width. Order in the form decides which ones pair up:
  // first_name + last_name land on one row, custom#website + company_tax_id on the next.
  const HALF_WIDTH_FIELDS = ['first_name', 'last_name', 'custom#website', 'company_tax_id'];

  const halfWidthSelector = HALF_WIDTH_FIELDS.map(
    (id) => `form[data-testid="form"] > :has(> [data-testid="field-${id}"])`
  ).join(',\n');

  // Heading rendered above the first field. Generated content, not a DOM node:
  // the form is React and would reconcile an appended node away on re-render.
  const LEAD_HEADING = 'Company & contact';

  const CSS = `
    // form[data-testid="form"]::before {
    //   content: '${LEAD_HEADING}';
    //   display: block;
    //   font-weight: 600;
    //   margin-bottom: -15px;
    //   font-weight: 600;
    //   font-size:14px;
    //   color: #202020;
    // }

    /* Section labels the app renders itself, e.g. "Rechnungsadresse". */
    form[data-testid="form"] legend {
      font-weight: 600;
    }

    /* Consent text below the submit button. It sits outside the form, and has no
       data-testid, so match the stable prefix of its hashed class. */
    [class*="_formDisclaimer_"] {
      text-align: center !important;
          font-size: 12px !important;
    }
    [class*="_formDisclaimer_"] a{
      color: var(--body-text-color);
    }
    /* Side-by-side fields on desktop only. Below this the app's own stacked
       layout is left alone — we never turn the form into a grid at all. */
    @media screen and (min-width: 750px) {
      form[data-testid="form"] {
        display: grid;
        grid-template-columns: 1fr 1fr;
        column-gap: 12px;
      }

      /* Everything spans the full form by default; only the opted-in fields go half width. */
      form[data-testid="form"] > *,
      form[data-testid="form"]::before {
        grid-column: 1 / -1;
      }

      ${halfWidthSelector} {
        grid-column: span 1;
      }
    }
  `;

  function applyLayout(host) {
    const root = host.shadowRoot;
    if (!root || root.__nbdcFormsLayout) return;

    const sheet = new CSSStyleSheet();
    sheet.replaceSync(CSS);
    root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];
    root.__nbdcFormsLayout = true;
  }

  function applyToAll() {
    document.querySelectorAll('shopify-forms-embed').forEach(applyLayout);
  }

  customElements.whenDefined('shopify-forms-embed').then(() => {
    applyToAll();
    // Forms can mount after page load (popups, lazily hydrated app blocks).
    new MutationObserver(applyToAll).observe(document.body, { childList: true, subtree: true });
  });
})();